import { AAuthForm } from '#components'
import { defu } from 'defu'

export function useAuthFormModal(
  options: Partial<ComponentProps<typeof AAuthForm>> = {},
) {
  const localePath = useLocalePath()
  const { t } = useI18n()

  const signInAttrs = {
    callbackUrl: localePath({ name: 'account' }),
    external: true,
  }

  const authFormModal = useModal({
    component: () =>
      h(
        AAuthForm,
        defu(options, {
          allFormProps: {
            submitAttrs: {
              block: true,
              class: 'shadow-md shadow-black/15',
              color: 'black',
              size: 'xl',
            },
          },
          canRegister: true,
          loginFormProps: {
            signInAttrs,
            socialProviders: ['google'],
          },
          registerFormProps: {
            signInAttrs,
          },
        }) as any,
      ),
    modalAttrs: {
      size: '2xs',
      title: t('components.aLoginFormModal.title'),
    },
  })

  return {
    authFormModal,
  }
}
